import { useQuery } from "@tanstack/react-query"
import { getExpenseNotifyList, sendNotifaction } from "./UseExpNotify"


interface paramsInterface{
  orgUnit?:number| null,
  start?:number,
  length?:number,
  search?:string,
  sortColumn?:string | null, 
  sortOrder?:string  | null

}


export const useGetExpsenNotifyList = ({enable=false,params={}}:{enable:boolean,params:paramsInterface})=>{
    return useQuery({
        queryKey:['GET_EXPENSE_NOTIFY_LIST',params],
        queryFn:()=>getExpenseNotifyList(params),
        enabled:enable,
        retry:false,
    })
}
export const useSendNotification =({enable=false,params={}}:{enable:boolean,params:any})=>{
  return useQuery({
       queryKey:['SEND_EXPENSE_NOTIFY_NOTICATION',params],
       queryFn:()=>sendNotifaction(params),
       enabled:enable,
       retry:false
  })
} 